export enum PaymentType {
  Stripe_Checkout = 1,
  Cash = 2
}
